/**
 * Created by DynamicDog on 2017-02-20.
 */
import {Component} from '@angular/core';
import {EtikettService} from "../services/etikett.service";
import {NetworkService} from "../services/network.service";
@Component({
    selector: 'bidrag-panel',
    template: `
            <h1>{{'Ladda upp ditt bidrag'|translate}}</h1>
            <p>{{'Vinnaren presenteras här på sajten den XX mars'|translate}}</p>
            
            <div id="entries">
                <div *ngFor="let entry of networkService.getEntries();let i = index" class="entry">
                    <img [src]="getThumbPath(entry.uuid)">
                    <b>{{entry.contestant}}</b>
                    <p>{{entry.title}}</p>
                </div>
            </div>
        `,
})

export class BidragPanelComponent {
    constructor(private networkService:NetworkService) {

    }
    private getThumbPath(uuid:string) {
        return this.networkService.imagePath+'/'+uuid+'.jpg';
    }
    private onUpload() {
    }
}


// WEBPACK FOOTER //
// ./app/upload/bidragpanel.component.ts